import React, { useEffect } from 'react';

const CurrentTime = ({ setCurrentTime }) => {
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());  // 親コンポーネントのstateを更新
    }, 1000);  // 1秒ごとに更新

    // コンポーネントがアンマウントされる時にインターバルをクリア
    return () => clearInterval(intervalId);
  }, [setCurrentTime]);

  return (
    <>
    </>
  );
};

export default CurrentTime;
